import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import React from "react";
import {
  useLoginUserMutation,
  useRegisterUserMutation,
} from "../../services/auth.api.ts";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../app/hooks.ts";
import { setUser } from "../../features/authSlice.ts";
import "./auth.css"

// Initial state for registering / sign up
const initialState = {
  agent_company_name: "",
  agent_email: "",
  agent_username: "",
  agent_password: "",
  confirmPassword: "",
};

const Auth = () => {
  const [formValue, setFormValue] = useState(initialState);

  // Full form value (Register)
  const {
    agent_company_name,
    agent_email,
    agent_username,
    agent_password,
    confirmPassword,
  } = formValue;

  // UseState to change form between login and register
  const [showRegister, setShowRegister] = useState(false);

  // Used to dispatch an action
  const dispatch = useAppDispatch();

  // Used to navigate to different routes
  const navigate = useNavigate();

  // Handling user login with authAPI
  const [
    loginUser, // defined in authApi.ts, it will accept the username and password
    { // properties will render after the successful api request
      data: loginData,
      isSuccess: isLoginSuccess,
      isError: isLoginError,
      error: LoginError,
    },
  ] = useLoginUserMutation();

  //! REGISTER IS NOT WORKING YET
  const [
    registerUser,
    {
      data: registerData,
      isSuccess: isRegisterSuccess,
      isError: isRegisterError,
      error: RegisterError,
    },
  ] = useRegisterUserMutation();

  // Handle form change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  //A Handling Form Submission
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (showRegister) {
      handleRegister();
    } else {
      handleLogin();
    }
  };
  
  //A.1 Handling the login request:
  const handleLogin = async () => {
    if (agent_username && agent_password) {
      await loginUser({ agent_username, agent_password }); // sending agent_username and agent_password into loginUser, defined in authApi in useLoginUserMutation
    } else {
      toast.error("Please fill all input fields");
    }
  };

  //A.2 Handling the register request:
  //! NOT WORKING YET
  const handleRegister = async () => {
    if (agent_password !== confirmPassword) {
      return toast.error("Password doesn't match");
    }

    if (agent_company_name && agent_password && agent_email && agent_username) {
      await registerUser({
        agent_company_name,
        agent_email,
        agent_username,
        agent_password,
      });
    } else {
      toast.error("Please fill all input fields");
    }
  };

  // Runs ONCE when isLoginSuccess becomes true
  useEffect(() => {
    console.log("Login Data:", loginData);
    console.log("Is Login Success:", isLoginSuccess);

    if (isLoginSuccess && loginData) {
      console.log(loginData);
      toast.success("User Login Successfully");
      dispatch(
        setUser({ // This is defined by how the data is being sent in the response body from the backend
          agentData: loginData.data // Updated to match the new response structure
        })
      );
      navigate("/dashboard");
    }
    //! NO REGISTER YET
    if (isRegisterSuccess && registerData) {
      toast.success("User Registered Successfully");
      // dispatch(
      //   // setUser({
      //   //   // user_id: .user_id,
      //   //   // user_type: loginData.user_type,
      //   //   // user_data: loginData.user_data,
      //   //   // access_token: loginData.access_token,
      //   //   // refresh_token: loginData.refresh_token,
      //   // })
      // );
      navigate("/dashboard");
    }
  }, [
    isLoginSuccess,
    loginData,
    dispatch,
    navigate,
    isRegisterSuccess,
    registerData
  ]);

  useEffect(() => {
    if (isLoginError && LoginError) {
      toast.error((LoginError as any).data.message);
    }
    if (isRegisterError && RegisterError) {
      toast.error((RegisterError as any).data.message);
    }
  }, [isLoginError, LoginError, isRegisterError, RegisterError]);

  return (
    <section className="auth-page">
      <div className="login-main">
        <div className="login-left">
          {/* Background Image */}
          <img src="/images/agents_icon.svg" alt="Background" />
        </div>
        <div className="login-right">
          <div className="login-right-container">
            <div className="login-logo">
              {/* Logo Image */}
              <img src="/images/Ticket.svg" alt="Logo" />
            </div>
            <div className="login-center">
              <h2 className="text--light">
                {!showRegister ? "Welcome back!" : "Register"}
              </h2>
              <p className="text--light">
                {!showRegister
                  ? "Please enter your Email & Password"
                  : "Please enter your Details"}
              </p>

              <form
                name="auth-form"
                onSubmit={handleSubmit}
              >
                {/* Show agent_company_name and agent_email inputs ONLY WHEN REGISTERING */}
                {showRegister && (
                  <>
                    <div className="form-group">
                      <label className="text--light" htmlFor="agent_company_name">Company Name</label>
                      <input
                        type="text"
                        id="agent_company_name"
                        name="agent_company_name"
                        value={agent_company_name}
                        onChange={handleChange}
                        className="form-input"
                      />
                    </div>
                    <div className="form-group">
                      <label className="text--light" htmlFor="agent_email">Email</label>
                      <input
                        type="email"
                        id="agent_email"
                        name="agent_email"
                        value={agent_email}
                        onChange={handleChange}
                        className="form-input"
                      />
                    </div>
                  </>
                )}
                {/* Show agent_username and agent_password inputs always, when logging in and when registering */}
                <div className="form-group">
                  <label className="text--light" htmlFor="agent_username">Username</label>
                  <input
                    type="text"
                    id="agent_username"
                    name="agent_username"
                    value={agent_username}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label className="text--light" htmlFor="agent_password">Password</label>
                  <input
                    type="password"
                    id="agent_password"
                    name="agent_password"
                    value={agent_password}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
                {/* Show confirm password input ONLY WHEN REGISTERING */}
                {showRegister && (
                  <div className="form-group">
                    <label className="text--light" htmlFor="confirmPassword">Confirm Password</label>
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>
                )}

                <div className="button-div">
                  <button type="submit" className="login-button">
                    {!showRegister ? "Log In" : "Register"}
                  </button>
                </div>
              </form>

              <p className="login-bottom-p">
              {!showRegister ? (
                <p className="text--light">
                  Don't have an account?{" "}
                  <a onClick={() => setShowRegister(true)}>Sign Up</a>
                </p>
              ) : (
                <p className="text--light">
                  Already have an account?{" "}
                  <a onClick={() => setShowRegister(false)}>Sign In</a>
                </p>
              )}
            </p>
            </div>
          </div>
        </div>
      </div>
  </section>

  );
};

export default Auth;
